import * as _ from 'lodash';
import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import {BehaviorSubject} from 'rxjs';
import {CallLogsExportRequest} from '../../api/models/call-logs-export-request';
import {NotificationService} from '../../notification/notification.service';
import {CallLogsFilterRequest} from '../../api/models/call-logs-filter-request';
import {RecordingsService as RecordingsApiService} from '../../api/services/recordings.service';

@Injectable()
export class CallLogsService {

  public callLogData = new BehaviorSubject<any>(null);
  public callLogAggregates: any = {};

  public exportColumns: any[] = [
    {id: _.uniqueId('id_'), field: 'fromFull', title: 'From', width: 20},
    {id: _.uniqueId('id_'), field: 'toFull', title: 'To', width: 20},
    {id: _.uniqueId('id_'), field: 'callType', title: 'Type', width: 10},
    {id: _.uniqueId('id_'), field: 'callStatus', title: 'Call Status', width: 10},
    {id: _.uniqueId('id_'), field: 'statusBy', title: 'Answered By', width: 10},
    {id: _.uniqueId('id_'), field: 'start', title: 'Date & Time', width: 20, style: {numFmt: 'DD/MM/YYYY hh:mm:ss AM/PM'}},
    {id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Talk Time', width: 10},
    {id: _.uniqueId('id_'), field: 'durationTotalFormatted', title: 'Total Time', width: 10},
  ];

  public exportAdditionalColumns: any[] = [
    {id: _.uniqueId('id_'), field: 'durationIvrFormatted', title: 'IVR Time', width: 10},
    {id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Hold Time', width: 10},
    {id: _.uniqueId('id_'), field: 'durationIdleFormatted', title: 'Idle Time', width: 10},
  ];

  public allExportColumns: any[] = [];

  constructor(
    private authService: AuthService,
    private notificationsService: NotificationService,
    private reportsApiService: ReportsApiService,
    private recordingsApiService: RecordingsApiService
  ) {
    this.allExportColumns = this.exportColumns.concat(this.exportAdditionalColumns);
  }

  public getExportColumns(includeAdditionalColumns) {
    return includeAdditionalColumns ? this.exportColumns.concat(this.exportAdditionalColumns) : this.exportColumns;
  }

  public async getCallDetails(id: string): Promise<any> {
    return await this.reportsApiService.reportsGetCallDetails({id: id}).toPromise();
  }

  public async exportLogs(state: CallLogsExportRequest): Promise<void> {
    console.log(state);

    await this.reportsApiService.callLogsGetExport({body: state}).toPromise();
    this.notificationsService.notifySuccess('Export is in progress. You will get notification then download is finished.');
    return;
  }

  async deleteRecording(callRecId, recId, domain, cdrDate) {
    await this.recordingsApiService.recordingsDeleteRecording({
      callRecId: callRecId,
      recId: recId,
      domain: domain,
      cdrDate: cdrDate
    }).toPromise();
  }

}
